// extracted by mini-css-extract-plugin
export default {"accordion-box":"Stories_accordion-box__6pjHY","stories-number":"Stories_stories-number__+lVIy","story-border":"Stories_story-border__ZN-Q3"};